import { styled } from '../../../../core/theme/styled';

export const StyledNarrowCenteredContainer = styled.div`
  text-align: center;
  width: 80%;
  margin: 0 auto;
`;
